module.exports = __webpack_public_path__ + "img/glass-group-b.f2409aa7.png";